/**
 * Iter 67en++++ — Google Search Console meta-tag verification injector.
 *
 * Reads `gsc_verification_token` from the public `/api/site-settings`
 * endpoint and writes (or updates) a single
 *   <meta name="google-site-verification" content="..." />
 * tag in `<head>`. Mounted once at the app root in App.js.
 *
 * Why this works for Google: Googlebot has rendered JavaScript since
 * 2019, so a meta tag injected on first paint is observed during the
 * crawl. The token is also a public string (Google's docs explicitly
 * mark it as safe to share) so there's no exposure risk in serving it
 * via the public site-settings endpoint.
 */
import { useEffect } from "react";
import api from "@/lib/api";

const META_NAME = "google-site-verification";

export default function GscMetaInjector() {
  useEffect(() => {
    let cancelled = false;
    api.get("/site-settings")
      .then(({ data }) => {
        if (cancelled) return;
        const token = (data?.gsc_verification_token || "").trim();
        if (!token) return;
        let el = document.querySelector(`meta[name="${META_NAME}"]`);
        if (!el) {
          el = document.createElement("meta");
          el.setAttribute("name", META_NAME);
          document.head.appendChild(el);
        }
        el.setAttribute("content", token);
      })
      .catch(() => { /* swallow — never break the app for an SEO meta tag */ });
    return () => { cancelled = true; };
  }, []);
  return null;
}
